/* tslint:disable */
/* eslint-disable */
/**
 * MedServer
 * API for managing esklepios resources.
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Response for get transactions
 * @export
 * @interface TransactionResponse
 */
export interface TransactionResponse {
    /**
     * Unique identifier of the financialChanel
     * @type {number}
     * @memberof TransactionResponse
     */
    financialChannelId?: number;
    /**
     * the type of the channel
     * @type {string}
     * @memberof TransactionResponse
     */
    channelTitle?: string;
    /**
     * Unique identifier of the financialChanel
     * @type {number}
     * @memberof TransactionResponse
     */
    sourceFinancialChannelId?: number;
    /**
     * the type of the channel
     * @type {string}
     * @memberof TransactionResponse
     */
    sourceChannelTitle?: string;
    /**
     * amount of the transaction
     * @type {string}
     * @memberof TransactionResponse
     */
    amount?: string;
    /**
     * code iso of currency
     * @type {string}
     * @memberof TransactionResponse
     */
    currencyIso?: string;
    /**
     * 
     * @type {boolean}
     * @memberof TransactionResponse
     */
    isLocked?: boolean;
    /**
     * date and time of transaction
     * @type {string}
     * @memberof TransactionResponse
     */
    transactionDateTime?: string;
    /**
     * direction of transaction
     * @type {string}
     * @memberof TransactionResponse
     */
    transactionDirection?: string;
    /**
     * Unique identifier of the transaction
     * @type {number}
     * @memberof TransactionResponse
     */
    transactionId?: number;
    /**
     * Information of transaction
     * @type {string}
     * @memberof TransactionResponse
     */
    transactionInfo?: string;
}

/**
 * Check if a given object implements the TransactionResponse interface.
 */
export function instanceOfTransactionResponse(value: object): value is TransactionResponse {
    return true;
}

export function TransactionResponseFromJSON(json: any): TransactionResponse {
    return TransactionResponseFromJSONTyped(json, false);
}

export function TransactionResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): TransactionResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'financialChannelId': json['financialChannelId'] == null ? undefined : json['financialChannelId'],
        'channelTitle': json['channelTitle'] == null ? undefined : json['channelTitle'],
        'sourceFinancialChannelId': json['sourceFinancialChannelId'] == null ? undefined : json['sourceFinancialChannelId'],
        'sourceChannelTitle': json['sourceChannelTitle'] == null ? undefined : json['sourceChannelTitle'],
        'amount': json['amount'] == null ? undefined : json['amount'],
        'currencyIso': json['currencyIso'] == null ? undefined : json['currencyIso'],
        'isLocked': json['isLocked'] == null ? undefined : json['isLocked'],
        'transactionDateTime': json['transactionDateTime'] == null ? undefined : json['transactionDateTime'],
        'transactionDirection': json['transactionDirection'] == null ? undefined : json['transactionDirection'],
        'transactionId': json['transactionId'] == null ? undefined : json['transactionId'],
        'transactionInfo': json['transactionInfo'] == null ? undefined : json['transactionInfo'],
    };
}

export function TransactionResponseToJSON(json: any): TransactionResponse {
    return TransactionResponseToJSONTyped(json, false);
}

export function TransactionResponseToJSONTyped(value?: TransactionResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'financialChannelId': value['financialChannelId'],
        'channelTitle': value['channelTitle'],
        'sourceFinancialChannelId': value['sourceFinancialChannelId'],
        'sourceChannelTitle': value['sourceChannelTitle'],
        'amount': value['amount'],
        'currencyIso': value['currencyIso'],
        'isLocked': value['isLocked'],
        'transactionDateTime': value['transactionDateTime'],
        'transactionDirection': value['transactionDirection'],
        'transactionId': value['transactionId'],
        'transactionInfo': value['transactionInfo'],
    };
}

